import { CURRENT_URL } from '@/src/constants/env';
import { WoodyLogLevel } from '@fabric/woody-client';
import process from 'process';

export const woodyLogLevel: WoodyLogLevel =
  process.env.REACT_APP_ENV === 'production' ? WoodyLogLevel.ERROR : WoodyLogLevel.LOG;

// Defined here because it depends on CURRENT_URL, and sometimes the CURRENT_URL is not defined when importing this file
export const REDIRECTOR_URL = process.env.NEXT_PUBLIC_LINK_WEBSITE_URL ?? CURRENT_URL;

const isLocalhost = (url: string) => {
  try {
    const urlObject = new URL(url);
    return urlObject.hostname === 'localhost';
  } catch {
    return false;
  }
};

const isSameHost = (url: string, url2: string) => {
  try {
    const urlObject = new URL(url);
    const urlObject2 = new URL(url2);
    return urlObject.hostname === urlObject2.hostname;
  } catch {
    return false;
  }
};

export const USE_WOODY_PROXY =
  (process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'develop') &&
  !isLocalhost(process.env.REACT_APP_WOODY_API_URL ?? '') &&
  !isSameHost(process.env.REACT_APP_WOODY_API_URL ?? '', CURRENT_URL)
    ? true
    : false;

export const WOODY_API_URL = USE_WOODY_PROXY
  ? `${CURRENT_URL}/api/woody-proxy`
  : process.env.REACT_APP_WOODY_API_URL;

if (!WOODY_API_URL) {
  throw new Error('REACT_APP_WOODY_API_URL ENV variable is undefined');
}
